import React from 'react'

import Img from 'gatsby-image'
import styled from 'styled-components'

import Grid, { BreakoutContent, Col } from '../components/Grid'

import Body from '../components/Body'
import FadeIn from '../components/FadeIn'
import Layout from '../components/Layout.js'
import { graphql } from 'gatsby'
import Paragraphs from '../components/Paragraphs'
import { Helmet } from 'react-helmet'

const AboutPage = props => {
  const { data } = props

  const {
    title,
    body: { processed: body },
    field_description: description,
    relationships: {
      paragraphs,
      field_image: {
        localFile: {
          childImageSharp: { ogImage, fluid: mainImage },
        },
      },
      field_atmosphere: {
        localFile: {
          childImageSharp: { fluid: atmosphereImage },
        },
      },
    },
  } = data.cms

  const BreakoutContentE = styled(BreakoutContent)`
    align-self: flex-start;
  `

  return (
    <Layout location={props.location}>
      <Helmet>
        <title>{title} | Wow my day</title>
        <meta name="description" content={description} />
        <meta name="og:image" content={ogImage.src} />
      </Helmet>
      <FadeIn>
        <div className="l-constrained">
          <Grid top>
            <Col padded right flat>
              <h1 style={{ display: 'none' }}>{title}</h1>
              <Body dangerouslySetInnerHTML={{ __html: body }} />
            </Col>
            <Col>
              <BreakoutContentE breakoutRight={1}>
                <Img fluid={mainImage} />
              </BreakoutContentE>
            </Col>
          </Grid>
        </div>
        <Img fluid={atmosphereImage} />
        <Paragraphs data={paragraphs} />
      </FadeIn>
    </Layout>
  )
}

export default AboutPage

export const query = graphql`
  query about {
    cms: nodePage {
      ...Paragraphs
      id
      title
      field_description
      body {
        processed
      }
      relationships {
        field_image {
          localFile {
            childImageSharp {
              ogImage: resize(width: 1200, height: 630) {
                src
              }
              fluid(maxWidth: 613, maxHeight: 495) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        field_atmosphere {
          localFile {
            childImageSharp {
              fluid(maxWidth: 1440, maxHeight: 373) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  }
`
